import React from "react";
import { HeroAdvancedSliceFragment } from "../../types/graphql";
import {
  HeroAdvancedBase,
  HeroAdvancedContainer,
  HeroAdvancedContent,
  HeroParallax,
} from "./hero-advanced.styled";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import {
  Background,
  Middleground,
  Foreground,
  Sun,
  Cloud1,
  Cloud2,
  Cloud3,
  Cloud4,
  Cloud5,
} from "./hero-advanced-svgs";

interface IHeroAdvancedProps {
  hero: HeroAdvancedSliceFragment;
}

const HeroAdvanced = (props: IHeroAdvancedProps) => {
  const hero = props.hero.primary;

  return (
    <HeroAdvancedBase>
      <HeroParallax>
        <HeroAdvancedContainer>
          <HeroAdvancedContent>
            <PrismicRichText
              field={hero.primary_heading.richText}
              components={htmlSerializer}
            />
            <PrismicRichText
              field={hero.primary_description.richText}
              components={htmlSerializer}
            />
          </HeroAdvancedContent>
        </HeroAdvancedContainer>
        <Sun />
        <Cloud1 />
        <Cloud2 />
        <Cloud3 />
        <Cloud4 />
        <Cloud5 />
        <Foreground />
        <Middleground />
        <Background />
      </HeroParallax>
    </HeroAdvancedBase>
  );
};

export default HeroAdvanced;
